import { AcceptAllButton } from '../AcceptAllButton';
import { MoreOptionsButton } from './MoreOptionsButton';
import { RejectButton } from './RejectButton';

type ActionButtonsModel = {
  moreOptionsId?: string;
  rejectId?: string;
  acceptId?: string;
};

export const ActionButtons = ({ moreOptionsId, rejectId, acceptId }: ActionButtonsModel) => (
  <div class="accept-button-container">
    {moreOptionsId ? <MoreOptionsButton id={moreOptionsId} /> : null}
    {rejectId ? <RejectButton id={rejectId} /> : null}
    {acceptId ? <AcceptAllButton id={acceptId} /> : null}
  </div>
);
